<template>
  <div id="app1">
  <p>count {{ count }}</p>
  <p>{{message}}tes</p>
  <p>
    <button @click="add">+</button>
  </p>
</div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data: function () {
    return {
      message: 'test'
    }
  },
  methods: {
    ...mapMutations({
      add: 'incrementStore'
    })
  },
  computed: mapState(['count'])
}
</script>
